import React from "react";
// import { Form, Field } from 'react-final-form';
// import { TextField } from 'final-form-material-ui';
import {
  TextInput,
  regex,
  number,
  required,
  minLength,
  maxLength
} from "react-admin";

// import Snackbar from '@material-ui/core/Snackbar';
import { Paper, Grid, Button } from "@material-ui/core";

// import MuiAlert from '@material-ui/lab/Alert';
import { green } from "@material-ui/core/colors";
// import clsx from 'clsx';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import { useDataProvider, useNotify, useRedirect } from 'react-admin';
// import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
// import Container from '@material-ui/core/Container';
// import AppBar from "../../header/index"
// import AppProvider from "./../../bootstrap/index"
// import * as yup from "yup"
// import { setIn } from "final-form";
// import Parse from 'parse'
const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },

  form: {
    width: "100%",
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  TextField: {
    marginTop: "8%",
    backgroundColor: "#ffffff"
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "40px"
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
    width: "100%"
  },
  buttonSuccess: {
    backgroundColor: "primary",
    width: "100%",
    "&:hover": {
      backgroundColor: "primary"
    }
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

const validateIFSC = regex(
  /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/,
  "Incorrect IFSC code"
);
const validateaccountNumber =  [required(), number(),minLength(10), maxLength(15)];

const validateAccountnameandbackname = regex(/^[A-Za-z\s]{1,}[\]{0,1}[A-Za-z\s]{0,}$/, "It must characters only");

// const validateAccountnameandbackname = regex(
//   /^[a-zA-z]+([\s][a-zA-Z]+)*$/,
//   "It must contain characters,should have maximum 20 charachters"
// );
// const validateAccountnameandbackname = regex(
//   /^[a-z]{0,1}$/,
//   "It must contain characters,sh ould have maximum 20 charachters"
// );
export const PaymentDetails = ({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values
}) => {
  const classes = useStyles();

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Paper style={{ padding: 16, boxShadow: "none" }}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <TextInput
              source="accountName"
              variant="standard"
              validate={[required(),minLength(5), maxLength(50), validateAccountnameandbackname]}
              fullWidth
              label="Account Holder Name"
            />
          </Grid>
          <Grid item xs={12}>
            {/* <NumberInput source="accountNumber"
           variant="standard"
           maxLength={ 2 } 

              validate={[required(),validateaccountNumber]}
              fullWidth label="Account Number" /> */}
            <TextInput
              source="accountNumber"
              variant="standard"
              validate={validateaccountNumber}
              fullWidth
              label="Account Number"
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              source="IFSC"
              variant="standard"
              validate={[required(), validateIFSC]}
              fullWidth
              label="IFSC Code"
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              source="bankName"
              variant="standard"
              fullWidth
              label="Bank Name"
              validate={[required(),minLength(5), maxLength(50), validateAccountnameandbackname]}
            />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 16, width: "100%" }}>
            <div className={classes.wrapper}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                // className={buttonClassname}
              >
                Submit Details
              </Button>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
};
export default PaymentDetails;
